export default __webpack_public_path__ + "static/card-1-9429ebcaf4c90bd7e4914e6f90e91310.svg";